import * as React from "react";
import { editType } from "../Settings/EditType";
import { FAButton } from "../SharedReact/BasicElements";
export class PlaybackPanel extends React.Component {
    constructor(props) {
        super(props);
        this._markerCenteredChanged = this._markerCenteredChanged.bind(this);
        this._playingStateChanged = this._playingStateChanged.bind(this);
        editType.markerCenteredChanged.addListener(this._markerCenteredChanged);
        this.state = {
            playing: this.props.songManager.playing,
            markerCentred: editType.markerCentered,
        };
    }
    _playingStateChanged(value) {
        this.setState({ playing: value });
    }
    _markerCenteredChanged(value) {
        this.setState({ markerCentred: value });
    }
    componentDidMount() {
        this.props.songManager.playingChangedEvent.addListener(this._playingStateChanged);
    }
    componentWillUnmount() {
        this.props.songManager.playingChangedEvent.removeListener(this._playingStateChanged);
    }
    render() {
        let c = "panelButton buttonAnim";
        return React.createElement("div", { className: "playbackPanel" },
            React.createElement("div", { className: "playbackButtons" },
                React.createElement(PlayPauseButton, { className: c, playing: this.state.playing, playFunction: () => { this.props.songManager.start(); }, pauseFunction: () => { this.props.songManager.stop(); } }),
                React.createElement(FAButton, { className: c, title: "Stop", iconName: "fa fa-stop", onClick: () => { this.props.songManager.stopToBeginning(); this.setState({ playing: this.props.songManager.playing }); } })),
            React.createElement("button", { className: "recentreButton buttonAnim", onClick: () => { editType.markerCentered = true; }, style: { visibility: ((!this.state.markerCentred && this.props.songManager.playing) ? "visible" : "hidden") } }, "Recentre Marker"));
    }
}
class PlayPauseButton extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        let icon = null;
        let func = null;
        let title = "";
        if (this.props.playing) {
            title = "Pause";
            icon = "fa fa-pause";
            func = this.props.pauseFunction;
        }
        else {
            title = "Play";
            icon = "fa fa-play";
            func = this.props.playFunction;
        }
        return React.createElement(FAButton, { title: title, className: this.props.className, iconName: icon, onClick: func });
    }
}
//# sourceMappingURL=PlaybackPanel.js.map